import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
}
export const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  onChange
}) => {
  const [color, setColor] = useState(value);
  const handleColorChange = (newColor: string) => {
    setColor(newColor);
    onChange(newColor);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setColor(newValue);
    onChange(newValue);
  };
  const presetColors = ['#000000', '#ffffff', '#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff', '#ff8800', '#8800ff', '#0088ff', '#88ff00', '#ff0088', '#666666', '#999999'];
  return <div className="p-2 space-y-2">
      <HexColorPicker color={color} onChange={handleColorChange} style={{
      width: '180px',
      height: '120px'
    }} />
      
      <div className="space-y-1">
        <Label className="text-xs font-medium">Hex Value</Label>
        <Input value={color} onChange={handleInputChange} placeholder="#000000" className="h-7 text-xs" />
      </div>

      
    </div>;
};